/**
 * @generated SignedSource<<667a8f56669a53e877e1c8afb6ad3610>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRelatedItemsSection_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_viewer" | "useSbSharedItemTracking_viewer">;
  readonly " $fragmentType": "SharedRelatedItemsSection_viewer";
};
export type SharedRelatedItemsSection_viewer$key = {
  readonly " $data"?: SharedRelatedItemsSection_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRelatedItemsSection_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSbSharedItemTracking_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0248779c0de1b6d1535ccf8af923281c";

export default node;
